import React, {
  ElementType,
  FunctionComponent,
  PropsWithChildren,
} from 'react';

import { default as MuiPaper, PaperProps } from '@mui/material/Paper';

const Paper: FunctionComponent<PaperProps<ElementType>> = (
  props: PropsWithChildren<PaperProps<ElementType>>
) => {
  return <MuiPaper {...props} />;
};

export default Paper;
